import completeProfileImage from "../images/athlete-home/complete-profile.png";
import ncaaTrackerImage from "../images/athlete-home/ncaa-tracker.png";
import calendarImage from "../images/athlete-home/calendar.png";
import collegeListImage from "../images/athlete-home/college-list.png";
import nilMicrocourseImage from "../images/athlete-home/nil-microcourse.png";
import mediaKitImage from "../images/athlete-home/media-kit.png";
import hubProgramImage from "../images/athlete-home/hub-program.png";

export type AthleteOnboardingWizardPreview = {
    id: string;
    label: string;
    image: string;
    imageAlt: string;
};

export type AthleteOnboardingWizardStep =
    | {
          id: "welcome";
          kind: "welcome";
          title: string;
          subtitle: string;
          body: string[];
          highlightedPhrase?: string;
      }
    | {
          id: "get-started" | "build-plan" | "explore-resources";
          kind: "preview-grid";
          heading: string;
          subtitle: string;
          previews: AthleteOnboardingWizardPreview[];
      }
    | {
          id: "start-journey";
          kind: "finish";
          heading: string;
          body: string;
          highlight: string;
      };

export const ATHLETE_ONBOARDING_WIZARD_STEPS: AthleteOnboardingWizardStep[] = [
    {
        id: "welcome",
        kind: "welcome",
        title: "Welcome to Polaris Athlete Hub",
        subtitle: "Your journey starts here.",
        body: [
            "Whether you're exploring college opportunities, learning about NIL, or preparing for life after high school, we're here to help.",
            "Complete three simple onboarding milestones to set up your account, explore your resources, and start building your future with confidence. Head to your Onboarding tab to get started!",
        ],
        highlightedPhrase: "three simple onboarding milestones",
    },
    {
        id: "get-started",
        kind: "preview-grid",
        heading: "GET STARTED",
        subtitle: "Build the foundation for your journey.",
        previews: [
            {
                id: "profile",
                label: "Complete Your Profile",
                image: completeProfileImage,
                imageAlt: "Preview of athlete profile setup",
            },
            {
                id: "ncaa",
                label: "Start Your NCAA Eligibility Tracker",
                image: ncaaTrackerImage,
                imageAlt: "Preview of NCAA eligibility tracker",
            },
            {
                id: "calendar",
                label: "Explore Calendar of Events",
                image: calendarImage,
                imageAlt: "Preview of calendar events",
            },
        ],
    },
    {
        id: "build-plan",
        kind: "preview-grid",
        heading: "BUILD YOUR PLAN",
        subtitle: "Start turning your goals into a plan.",
        previews: [
            {
                id: "college-list",
                label: "Build Your List",
                image: collegeListImage,
                imageAlt: "Preview of college list planning",
            },
            {
                id: "nil-course",
                label: "Complete Your First NIL Microcourse",
                image: nilMicrocourseImage,
                imageAlt: "Preview of NIL microcourse",
            },
            {
                id: "media-kit",
                label: "Create Your NIL Media Kit",
                image: mediaKitImage,
                imageAlt: "Preview of NIL media kit",
            },
        ],
    },
    {
        id: "explore-resources",
        kind: "preview-grid",
        heading: "EXPLORE YOUR RESOURCES",
        subtitle: "Discover the tools and support available to you.",
        previews: [
            {
                id: "hub",
                label: "Explore Your Organization's Hub",
                image: hubProgramImage,
                imageAlt: "Preview of organization hub resources",
            },
        ],
    },
    {
        id: "start-journey",
        kind: "finish",
        heading: "START MY JOURNEY",
        body: "You'll find all of these steps in your Onboarding tab.",
        highlight: "We're excited to play a role in your future success.",
    },
];
